import { clsx } from "clsx";
import { useTableContext } from "./context";
import { TableLoadingRow } from "./TableLoadingRow";
import { TableRow } from "./TableRow";

type Props = {
  className?: string;
};

export function TableBody<Item>({ className }: Props) {
  const { items, loading } = useTableContext<Item>();

  if (loading) {
    return (
      <div className={clsx("nuco-table__body", className)}>
        {Array.from({ length: 6 }, (_, index) => (
          <TableLoadingRow key={`loading-row-${index}`} />
        ))}
      </div>
    );
  }

  return (
    <div className={clsx("nuco-table__body", className)}>
      {items.map((item, index) => {
        return <TableRow key={`row-${index}`} item={item} />;
      })}
    </div>
  );
}
